export const uploadAvatarStyle = {
	wrapper: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		width: '100%',
		maxWidth: '200px',
		height: '200px',
		textAlign: 'center',
		borderRadius: '50%',
		backgroundImage: `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='100' ry='100' stroke='%23515B75FF' stroke-width='1' stroke-dasharray='8' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e")`,
	},

	image: {
		'& img': {
			width: '200px',
			height: '200px',
			borderRadius: '50%',
		},
	},

	icon: {
		marginBottom: '12px',
	},

	title: {
		maxWidth: '154px',
		width: '100%',
		fontWeight: '400',
		color: 'var(--neutral-500)',
	},

	button: {
		fontSize: '14px',
		padding: '0 4px 3px 4px',
	},

	dragged: {
		backgroundImage: `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='100' ry='100' stroke='%2326B5EDFF' stroke-width='1' stroke-dasharray='8' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e")`,
	},
};
